import React, { useEffect, useState, useRef } from "react";
import Navbar from "../global/Navbar";
import Content from "../components/Details/Content";
import Instructor from "../components/Details/Instructor";
import Coursedetails from "../components/Details/Coursedetails";
import Payment from "../components/Details/Payment";
import Questions from "../components/Details/Questions";

import { Link, useParams } from "react-router-dom";
import Necessary from "../components/Details/Necessary";
import Learn from "../components/Details/Learn";
import Certificate from "./Certificate";

import PaymentModal from "../components/Details/PaymentModal.jsx";
import axios from "axios";
import Loading from "../utils/Loading.jsx";

const Details = () => {

  const { id } = useParams();
  const [active, setActive] = useState("content");
  const [isFixedDetails, setIsFixedDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [courses, setCourses] = useState();
  const [loading, setLoading] = useState(true);

  const courseId = parseInt(id);

  const contentRef = useRef(null);
  const paymentRef = useRef(null);
  const instructorRef = useRef(null);
  const questionsRef = useRef(null);
  const learnRef = useRef(null);
  const coursedetailsRef = useRef(null);
  const necessaryRef = useRef(null);
  const certificateRef = useRef(null);

  const fetchCourses = async () => {
    try {
      setLoading(true); // start loading
      const res = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/courses/${courseId}`
      );
      setCourses(res?.data);
    } catch (error) {
      console.error("❌ Failed to load Courses:", error);
    } finally {
      setLoading(false); // end loading
    }
  };

  useEffect(() => {

    fetchCourses();

    const handleScroll = () => {
      setIsFixedDetails(window.scrollY >= 600);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (ref) => {

    if (ref?.current) {
      const topOffset =
        ref.current.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-[#101e2b]">
        <Loading/>
      </div>
    );
  }

  if (!courses) {
    return (
      <div className="text-white text-center mt-10">
        কোর্স খুঁজে পাওয়া যায়নি।
      </div>
    );
  }

  const selectValue = "course";

  return (
    <>
      <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
        <Navbar />
        <div className="container flex flex-col gap-4 px-4 lg:px-0 relative mb-[5rem]">
          <div className="w-full flex lg:flex-row flex-col items-center gap-4 mt-[2rem] pb-[1rem]">
            {/* Course Text Section */}
            <div className="lg:w-1/2 w-full flex flex-col gap-4 order-2 lg:order-1 pb-2">
              <h2 className="text-4xl font-bold text-[#22BEFF] mt-[2rem]">
                {courses?.name}
              </h2>
              <p className="text-gray-200 font-normal text-xl sm:text-justify">
                {courses?.seo_description}
              </p>
            </div>

            {/* Course Video + Sidebar */}
            <div className="lg:w-2/6 w-full order-1 lg:order-2 p-4 border border-[#22BEFF33] bg-[#00294B] flex flex-col gap-4 static lg:absolute top-0 right-0 mt-[2rem]">
             
              <img src={`${import.meta.env.VITE_API_BASE_URL}/storage/${courses?.image}`} alt="image" className="rounded" loading="lazy"/>

              <div className="flex flex-col gap-4">
                <span className="flex items-center gap-4">
                  <span className="text-2xl font-bold text-[#22BEFF]">
                    ৳{courses?.current_price}
                  </span>
                  <del className="text-xl text-[#22BEFF]">
                    ৳{courses?.regular_price}
                  </del>
                </span>
                <button onClick={() => setShowModal(true)} className="z-10 w-full p-2 bg-[#22BEFF] font-semibold rounded-md cursor-pointer text-center block" >
                  কোর্সটি কিনুন
                </button>
              </div>

              <div className="flex flex-col gap-2 mt-4">
                <h1 className="text-gray-400 text-xl font-bold mb-4">
                  এই কোর্সে যা থাকছে
                </h1>
              
                {Array.isArray(courses?.content_Outline) ? courses.content_Outline.map((item, index) => (
                      <span key={index} className="flex items-center gap-2 text-gray-400 text-xl" >
                        {item.text}
                      </span>
                    ))
                  : (() => {
                      try {
                        const parsed = JSON.parse(
                          courses?.content_Outline || "[]"
                        );
                        return parsed.map((item, index) => (
                          <span key={index} className="flex items-center gap-2 text-gray-400 text-xl">
                            {item.text}
                          </span>
                        ));
                      } catch (e) {
                        console.error(
                          "❌ JSON parse error in content_Outline:",
                          e
                        );
                        return null;
                      }
                    })()}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content with Sections */}
      <div className="w-full min-h-screen flex flex-col items-center bg-[#00294B]">
        <div className="container flex gap-4 px-4 lg:px-0">
          {/* Left Column */}
          <div className="lg:w-1/2 w-full flex flex-col gap-4 mb-4">
            {/* Manual Tabs */}
            <div className="w-full flex items-center gap-4 mt-[2rem] overflow-auto thin-scrollbar">
              {[
                {
                  label: "কন্টেন্ট\u00A0প্রিভিউ",
                  ref: contentRef,
                  key: "content",
                },
                {
                  label: "কোর্সটি\u00A0করে\u00A0যা\u00A0শিখবেন",
                  ref: learnRef,
                  key: "learn",
                },
                {
                  label: "কোর্স\u00A0ইন্সট্রাক্টর",
                  ref: instructorRef,
                  key: "instructor",
                },
                {
                  label: "কোর্স\u00A0সম্পর্কে\u00A0বিস্তারিত",
                  ref: coursedetailsRef,
                  key: "coursedetails",
                },
                // { label: "যেভাবে\u00A0পেমেন্ট\u00A0করবেন", ref: paymentRef, key: "payment" },
                {
                  label: "ক্লাস\u00A0করার\u00A0জন্য\u00A0প্রয়োজন\u00A0হবে",
                  ref: necessaryRef,
                  key: "necessary",
                },
                {
                  label: "কোর্স\u00A0সার্টিফিকেট",
                  ref: certificateRef,
                  key: "certificate",
                },
                // { label: "সচরাচর\u00A0জিজ্ঞাসা", ref: questionsRef, key: "questions" },
              ].map((tab) => (
                <span key={tab.key} className={`py-2 cursor-pointer text-xl font-bold ${ active === tab.key ? "text-[#22BEFF] " : "text-gray-300"}`} onClick={() => { setActive(tab.key);scrollToSection(tab.ref);}}>
                  {tab.label}
                </span>
              ))}
            </div>

            {/* Tab Content Sections */}
            <div ref={contentRef} className="mt-4">
              <Content selectedCourse={courses} />
            </div>
            <div ref={learnRef} className="mt-4">
              <Learn selectedCourse={courses} />
            </div>
            <div ref={instructorRef} className="mt-4">
              <Instructor selectedCourse={courses} />
            </div>
            <div ref={coursedetailsRef} className="mt-4">
              <Coursedetails selectedCourse={courses} />
            </div>
            {/* <div ref={paymentRef} className="mt-4">
              <Payment selectedCourse={selectedCourse} />
            </div> */}
            <div ref={necessaryRef} className="mt-4">
              <Necessary />
            </div>
            <div ref={certificateRef} className="mt-4">
              <Certificate />
            </div>
            {/* <div ref={questionsRef} className="mt-4">
              <Questions selectedCourse={selectedCourse} />
            </div> */}
          </div>

          {/* Right Fixed Column */}
          <div className="w-1/2 relative lg:block hidden">
            <div className="w-2/3 h-[25rem]" />

            <div className={`h-[25rem] p-4 border border-[#22BEFF33] bg-[#00294B] flex flex-col gap-4 fixed w-[27rem] top-[8rem] right-[calc(16%)] ${ isFixedDetails ? "block" : "hidden"}`}>
              <div className="flex flex-col gap-4">
                <span className="flex items-center gap-4">
                  <span className="text-2xl font-bold text-[#22BEFF]">
                    ৳{courses?.current_price}
                  </span>
                  <del className="text-xl text-[#22BEFF]">
                    ৳{courses?.regular_price}
                  </del>
                </span>
                <button className="w-full p-2 bg-[#22BEFF] font-bold rounded-md cursor-pointer" onClick={() => setShowModal(true)}>
                  কোর্সটি কিনুন
                </button>
              </div>

              <div className="flex flex-col gap-2 mt-4">
                <h1 className="text-gray-400 text-xl font-bold mb-4">
                  এই কোর্সে যা থাকছে
                </h1>
                {Array.isArray(courses?.content_Outline)
                  ? courses.content_Outline.map((item, index) => (
                      <span key={index} className="flex items-center gap-2 text-gray-400 text-xl">
                        {item.text}
                      </span>
                    ))
                  : (() => {
                      try {
                        const parsed = JSON.parse(courses?.content_Outline || "[]");
                        return parsed.map((item, index) => (
                          <span key={index} className="flex items-center gap-2 text-gray-400 text-xl">
                            {item.text}
                          </span>
                        ));
                      } catch (e) {
                        console.error(
                          "❌ JSON parse error in content_Outline:",
                          e
                        );
                        return null;
                      }
                    })()}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      

      <PaymentModal showModal={showModal} setShowModal={setShowModal} id={courses.id} selectValue={selectValue}/>
    </>
  );
};

export default Details;
